import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import apiClient from "../apiClient";
import { Link } from "react-router-dom";

const Categories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect (() => {
        const fetchAllCategories = async () => {
            try {
                const res = await apiClient.get("/categories");
                setCategories(res.data);
            } catch (err) {
                setError("Failed to load categories.");
            } finally {
                setLoading(false);
            }
        };
        fetchAllCategories();
    }, []);

    const handleDelete = async (CategoryId) => {
        try {
          await apiClient.delete(`/categories/${CategoryId}`);
          setCategories((prev) => prev.filter((item) => item.CategoryId !== CategoryId));
        } catch (err) {
          setError("Delete failed. Please try again.");
        }
      };

    return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Categories</h1>
          <p className="page-subtitle"><Link to="/">Home</Link> / Categories</p>
        </div>
        <Link className="btn-link" to="/CategoriesAdd">Add Category</Link>
      </header>

      {error && <p className="notice notice-error">{error}</p>}
      {loading && <p className="notice notice-muted">Loading categories...</p>}

      {!loading && (
        <section className="resource-list">
          {categories.length === 0 ? (
            <p className="notice notice-muted">No categories yet.</p>
          ) : (
            categories.map((category) => (
              <article key={category.CategoryId} className="resource-row">
                <div>
                  <strong>{category.Description}</strong>
                  <div className="resource-meta">
                    Savings category: {Number(category.IsSavingsCategory) ? "Yes" : "No"}
                  </div>
                  <div className="resource-meta">
                    Income category: {Number(category.IsIncomeCategory) ? "Yes" : "No"}
                  </div>
                </div>
                <div className="actions">
                  <button className="btn btn-danger" onClick={() => handleDelete(category.CategoryId)}>Delete</button>
                  <Link className="btn-link" to={`/CategoriesUpdate/${category.CategoryId}`}>Update</Link>
                </div>
              </article>
            ))
          )}
        </section>
      )}
    </div>
    );
};

export default Categories;
